#import "../fragments/dromo-import-fragment.graphql"

query GetDromoImports($importIdentifier: ImportIdentifier!) {
    dromoImports(importIdentifier: $importIdentifier) {
        imports {
            ...DromoImportFragment
        }
        currentImport {
            importStatus
        }
        recentCompletedImport {
            importStatus
        }
    }
}
